module.exports = __webpack_public_path__ + "static/media/31.c0c2e866.jpeg";